import { DataType, Unit, VibrationSubType } from "@soft-db/data-formatter";
import { RecordQuery } from "@soft-db/monitoring-api-client";
import { deepCopy } from "@soft-db/soft-utils";
import { createPluginOptions } from "../create-plugin-options";
import { DataStyle } from "../type";

export type CartesianDataOptions = {
	id: string;
	style: DataStyle;
	query: RecordQuery;
};

export const defaultDataStyle = createPluginOptions<DataStyle>()({
	color: "indigo",
	lineWidth: "medium",
	antialiasing: false,
	lineDashStyle: "full",
	point: {
		visible: false,
		shape: "none",
		size: "medium",
	},
});

export const defaultCartesianAxisOptions = createPluginOptions()({
	type: "" as DataType | "",
	subType: "" as VibrationSubType | "",
	unit: "" as Unit | "",
	data: [] as CartesianDataOptions[],
	weeklyLimits: {
		exceedance: null as string | null,
		warning: null as string | null,
	},
});

export const defaultTimeHistoryDataOptions = createPluginOptions()({
	left: deepCopy(defaultCartesianAxisOptions),
	right: deepCopy(defaultCartesianAxisOptions),
});

export type TimeHistoryDataOptions = typeof defaultTimeHistoryDataOptions;
export type CartesianAxisDataOptions = typeof defaultCartesianAxisOptions;
